import styled from 'styled-components';
import { HeartIcon } from '@/shared/images/icons/HeartIcon';
import { cssVars } from '@/styles/Themes/cssVars';
import Screen from 'src/styles/Themes/Screen';
import Text from 'src/styles/Themes/Text';
import Palette from '@/styles/Themes/Palette';
import { radius, borders } from '@/styles/Themes/Metrics';

export const EmptyWishlist = styled.body`
    background-color: ${cssVars.bg_white_blue};
    padding: 38px 26px 30px;
    margin: 0 auto;
    min-height: 70vh;

    ${Screen.ipad} {
        text-align: center;
        padding: 60px 65px 40px;
    }
`;

export const EmptyWishlistImage = styled.div`
    position: relative;
    width: 288px;
    height: 191px;
    margin: 0 auto 43px;

    ${Screen.ipad} {
        width: 501px;
        height: 332px;
    }

    ${Screen.desktop} {
        width: 665px;
        height: 440px;
        margin: 0 auto 77px;
    }
`;

export const WishDescription = styled.div`
    color: ${cssVars.fg_gray2_gray3};
    margin-bottom: 25px;
    ${Text.Mobile.medium.regular};

    ${Screen.ipad} {
        ${Text.Ipad.large.regular};
        text-align: center;
        margin-bottom: 30px;
    }
    ${Screen.desktop} {
        ${Text.Desktop.heading4};
        margin: 20px 0 40px;
    }
`;

export const EmptyWishlistFirstText = styled.div`
    display: inline;
    position: relative;
    padding-right: 40px;

    ${Screen.ipad} {
        padding-right: 50px;
    }
    ${Screen.desktop} {
        padding-right: 45px;
    }
`;

export const EmptyWishlistSecondText = styled.div`
    display: inline;
    position: relative;
    padding-left: 5px;
`;

export const FixContainer = styled.div`
    width: 90%;
    margin: 10px auto 50px;
    min-height: 70vh;

    ${Screen.desktop} {
        max-width: 1124px;
        padding: 0 30px;
        margin: 60px auto;
    }
`;

export const WishHeader = styled.div`
    ${Text.Mobile.heading3};
    color: ${cssVars.fg_gray1_white};
    padding: 30px 10px 24px;

    ${Screen.ipad} {
        ${Text.Full.heading2};
    }

    ${Screen.desktop} {
        padding: 0 0 34px;
    }
`;

export const ActivitiesContainer = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 20px;
    margin-bottom: 40px;

    ${Screen.ipad} {
        grid-gap: 30px;
    }
    ${Screen.desktop} {
        grid-gap: 24px;
        grid-template-columns: 1fr 1fr;
        margin: 10px 0 24px;
    }
`;

export const IconWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: -13px;
    right: -1px;
    z-index: 1;
    cursor: pointer;
    background-color: ${cssVars.bg_white_dark3};
    border: ${borders.small} ${cssVars.bg_ash_darker};
    border-radius: ${radius.large};
    box-shadow: 0px 4px 23px ${cssVars.shadow_normal};
    height: 36px;
    width: 36px;

    ${Screen.ipad} {
        top: -10px;
        right: 2px;
    }

    ${Screen.desktop} {
        top: -6px;
        right: 1px;
    }
`;

export const WishListBtn = styled(HeartIcon)`
    width: 19px;
    height: 18px;
    stroke: ${Palette.state.error};
`;
